import { TooltipTrigger } from "@visiblethread/react-components";
import Flex from "components/Flex";
import { get, pick } from "lodash";
import {
  BookOpenText,
  Check,
  Cog,
  Notebook,
  Rows4,
  SpellCheck,
  SquareGanttChart,
  SquarePen,
  TableOfContentsIcon,
} from "lucide-react";
import { arrayOf, bool, number, object, string } from "prop-types";
import { pluralize } from "utils/string";

import classes from "./DocumentCounts.module.scss";

const ICON_SIZE = 16;

const COUNT_DICTIONARY = {
  documentCount: ["Document", SquareGanttChart],
  researchCount: ["Research Doc", Notebook],
  shreddingCount: ["Shred", Rows4],
  hasProposalOutline: ["Proposal Outline", TableOfContentsIcon],
  proposalWritingCount: ["Proposal Doc", SquarePen],
  writingAndEditingCount: ["Writing & Editing", SquarePen],
  acronymCount: ["Acronym Report", SpellCheck],
  amendmentCount: ["Compare Doc", BookOpenText],
  hasTechnicalAlignment: ["Technical Alignment", Cog],
};

const COUNT_DICTIONARY_KEYS = Object.keys(COUNT_DICTIONARY);

const DocumentCounts = ({ labelOverrides = {}, order, ...props }) => {
  const dictionary = { ...COUNT_DICTIONARY, ...labelOverrides };
  const keys = order ?? COUNT_DICTIONARY_KEYS;
  const existingKeys = pick(props, keys);

  return (
    <div className={classes["document_counts"]} data-testid="document-counts">
      {Object.keys(existingKeys).map((key) => {
        const isBool = key.startsWith("has");
        const value = get(props, key, isBool ? false : 0);
        const hasValue = Boolean(value);
        if (!hasValue) {
          return (
            <Flex justifyContent="center" className={classes.dummy} key={key}>
              -
            </Flex>
          );
        }

        const [title, Icon] = dictionary[key];
        const label = isBool ? title : `${value} ${pluralize(title, value)}`;

        return (
          <TooltipTrigger
            content={label}
            classes={classes["document_counts__item"]}
            key={key}
          >
            <Icon size={ICON_SIZE} arial-hidden="true" />

            <Flex
              justifyContent="center"
              className={classes["document_counts_sup"]}
            >
              {isBool ? <Check arial-hidden="true" size={14} /> : value}
            </Flex>
          </TooltipTrigger>
        );
      })}
    </div>
  );
};

DocumentCounts.propTypes = {
  documentCount: number,
  shreddingCount: number,
  amendmentCount: number,
  scratchpadCount: number,
  hasProposalOutline: bool,
  hasTechnicalAlignment: bool,
  labelOverrides: object,
  order: arrayOf(string),
};

export default DocumentCounts;
